import { render } from "./ViewDmccComponent.vue?vue&type=template&id=107b79b8"
import script from "./ViewDmccComponent.vue?vue&type=script&lang=js"
export * from "./ViewDmccComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__